<main id="app-root-general">
    <router-outlet></router-outlet>
</main>
